module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "page-bar"
  }, [_c('breadcrumb', {
    attrs: {
      "crumbs": _vm.breadcrumbArray
    }
  })], 1), _vm._v(" "), _c('h1', {
    staticClass: "page-title"
  }, [_vm._v("Printers")]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), (_vm.$root.activeLocation && _vm.$root.activeLocation.id && _vm.$root.permissions['printers create']) ? _c('div', {
    staticClass: "portlet box blue-hoki"
  }, [_c('div', {
    staticClass: "portlet-title bg-blue-chambray",
    on: {
      "click": function($event) {
        _vm.toggleNewPrinterPanel()
      }
    }
  }, [_vm._m(1, false, false), _vm._v(" "), _c('div', {
    staticClass: "tools"
  }, [_c('a', {
    class: {
      'expand': !_vm.newPrinterCollapse, 'collapse': _vm.newPrinterCollapse
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "portlet-body",
    class: {
      'display-hide': _vm.newPrinterCollapse
    }
  }, [_c('form', {
    attrs: {
      "role": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.createNewPrinter()
      }
    }
  }, [_c('div', {
    staticClass: "form-body row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.errorMessage.length) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-close": "alert"
    },
    on: {
      "click": function($event) {
        _vm.clearError()
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPrinter.printer_name),
      expression: "newPrinter.printer_name"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.newPrinter.printer_name.length
    },
    attrs: {
      "type": "text",
      "id": "form_control_1"
    },
    domProps: {
      "value": (_vm.newPrinter.printer_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newPrinter, "printer_name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_1"
    }
  }, [_vm._v("Printer Name")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPrinter.printer_key),
      expression: "newPrinter.printer_key"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.newPrinter.printer_key.length
    },
    attrs: {
      "type": "text",
      "id": "form_control_2"
    },
    domProps: {
      "value": (_vm.newPrinter.printer_key)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newPrinter, "printer_key", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_2"
    }
  }, [_vm._v("Printer Key")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPrinter.printer_serialno),
      expression: "newPrinter.printer_serialno"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.newPrinter.printer_serialno.length
    },
    attrs: {
      "type": "text",
      "id": "form_control_3"
    },
    domProps: {
      "value": (_vm.newPrinter.printer_serialno)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newPrinter, "printer_serialno", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_3"
    }
  }, [_vm._v("Printer Serial Number")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPrinter.copies),
      expression: "newPrinter.copies"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.newPrinter.copies.length
    },
    attrs: {
      "type": "text",
      "id": "form_control_4"
    },
    domProps: {
      "value": (_vm.newPrinter.copies)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newPrinter, "copies", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_4"
    }
  }, [_vm._v("Copies")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "side-by-side-wrapper"
  }, [_c('p', {
    staticClass: "paper-width-label"
  }, [_vm._v("Paper width:")]), _vm._v(" "), _c('el-dropdown', {
    attrs: {
      "trigger": "click",
      "size": "mini",
      "show-timeout": 50,
      "hide-timeout": 50
    },
    on: {
      "command": _vm.updateNewPrinterPaperWidth
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.newPrinter.paper_width)), (_vm.newPrinter.paper_width !== 'Select') ? _c('span', [_vm._v("mm")]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "58"
    }
  }, [_vm._v("58mm")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "80"
    }
  }, [_vm._v("80mm")])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "side-by-side-wrapper"
  }, [_c('p', {
    staticClass: "side-by-side-item status-label"
  }, [_vm._v("Status:")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-color": "#0c6",
      "inactive-color": "#ff4949",
      "active-value": 1,
      "inactive-value": 0,
      "active-text": "Enabled",
      "inactive-text": "Disabled"
    },
    model: {
      value: (_vm.newPrinter.status),
      callback: function($$v) {
        _vm.$set(_vm.newPrinter, "status", $$v)
      },
      expression: "newPrinter.status"
    }
  })], 1)])]), _vm._v(" "), _vm._m(2, false, false)])])]) : _vm._e(), _vm._v(" "), _c('loading-screen', {
    attrs: {
      "show": _vm.displayPrinters,
      "color": '#2C3E50',
      "display": 'inline'
    }
  }), _vm._v(" "), (!_vm.$root.activeLocation.id) ? _c('div', {
    staticClass: "alert alert-info center margin-top-20"
  }, [_c('h4', [_vm._v("No Store Selected")]), _vm._v(" "), _c('p', [_vm._v("Please select a store from the location panel on the right to view its printers")])]) : _vm._e(), _vm._v(" "), (_vm.$root.activeLocation && _vm.$root.activeLocation.id && _vm.storePrinters.length && !_vm.displayPrinters) ? _c('div', [_c('div', {
    staticClass: "portlet light portlet-fit bordered margin-top-20"
  }, [_vm._m(3, false, false), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [_c('div', {
    staticClass: "mt-element-list"
  }, [_c('div', {
    staticClass: "mt-list-container list-news"
  }, [_c('ul', _vm._l((_vm.storePrinters), function(printer) {
    return _c('li', {
      key: printer.id,
      staticClass: "mt-list-item actions-at-left margin-top-15",
      attrs: {
        "id": 'printer-' + printer.id
      }
    }, [_c('div', {
      staticClass: "list-item-actions"
    }, [(_vm.$root.permissions['printers update']) ? _c('el-tooltip', {
      attrs: {
        "content": "Edit",
        "effect": "light",
        "placement": "right"
      }
    }, [_c('a', {
      staticClass: "btn btn-circle btn-icon-only btn-default",
      on: {
        "click": function($event) {
          _vm.editPrinter(printer)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-lg fa-pencil"
    })])]) : _vm._e(), _vm._v(" "), (_vm.$root.permissions['printers read'] && !_vm.$root.permissions['printers update']) ? _c('el-tooltip', {
      attrs: {
        "content": "View",
        "effect": "light",
        "placement": "right"
      }
    }, [_c('a', {
      staticClass: "btn btn-circle btn-icon-only btn-default",
      on: {
        "click": function($event) {
          _vm.editPrinter(printer)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-lg fa-eye"
    })])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "list-datetime bold uppercase font-red"
    }, [_c('span', [_vm._v(_vm._s(printer.printer_name))])]), _vm._v(" "), _c('div', {
      staticClass: "list-item-content height-mod"
    }, [_c('div', {
      staticClass: "col-md-5"
    }, [_c('span', [_c('strong', [_vm._v("Printer Serial Number: ")]), _vm._v(_vm._s(printer.printer_serialno) + "\n\t\t                            \t\t")]), _c('br'), _vm._v(" "), _c('span', [_c('strong', [_vm._v("Paper Width: ")]), _vm._v(_vm._s(printer.paper_width) + "mm\n\t\t                            \t\t")]), _c('br')]), _vm._v(" "), _c('div', {
      staticClass: "col-md-5"
    }, [_c('span', [_c('strong', [_vm._v("Status: ")]), _vm._v(" "), (printer.status === 1) ? _c('span', [_vm._v("ON")]) : _c('span', [_vm._v("OFF")])]), _c('br'), _vm._v(" "), _c('span', [_c('strong', [_vm._v("Copies: ")]), _vm._v(_vm._s(printer.copies) + "\n\t\t                            \t\t")]), _c('br')])])])
  }))])])])])]) : _vm._e(), _vm._v(" "), (_vm.$root.activeLocation.id && !_vm.storePrinters.length && !_vm.displayPrinters) ? _c('div', [_c('no-results', {
    attrs: {
      "show": true,
      "type": 'printers'
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showEditPrinterModal) ? _c('edit-printer', {
    attrs: {
      "printerId": _vm.selectedPrinterId
    },
    on: {
      "closeEditPrinterModal": _vm.closeEditPrinterModal,
      "updatePrinter": _vm.updatePrinter
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "note note-info"
  }, [_c('p', [_vm._v("Create and manage printers for your store.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption"
  }, [_c('i', {
    staticClass: "fa fa-2x fa-plus-circle"
  }), _vm._v("\n\t\t\t\t\tSet Up a New Printer\n\t\t\t\t")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-actions right margin-top-20"
  }, [_c('button', {
    staticClass: "btn blue",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Create")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet-title bg-blue-chambray"
  }, [_c('div', {
    staticClass: "menu-image-main"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/client_logo.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "caption-subject font-green bold uppercase"
  }, [_vm._v("Printers")]), _vm._v(" "), _c('div', {
    staticClass: "caption-desc font-grey-cascade"
  }, [_vm._v("View and manage printers for the selected store.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24a8221f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/Printers/Printers.vue
// module id = 685
// module chunks = 0